/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieVideoLangViewModel } from "../types/SerieVideoLangViewModel.ts";

export const serieVideoLangViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da tradução do vídeo.")),
  serieVideoId: z.optional(
    z.number().int().describe("ID do vídeo ao qual a tradução pertence."),
  ),
  title: z.string().describe("Título do vídeo neste idioma.").nullish(),
  resumee: z
    .string()
    .describe("Resumo do vídeo neste idioma. Opcional.")
    .nullish(),
  embed: z.string().describe("HTML/embed do vídeo neste idioma.").nullish(),
  cultureInfo: z
    .string()
    .describe("Código do idioma (cultura) da tradução.")
    .nullish(),
  cultureDisplayName: z
    .string()
    .describe("Nome amigável do idioma da tradução.")
    .nullish(),
}) as unknown as ToZod<SerieVideoLangViewModel>;
